import { message } from 'antd';
import { useState } from 'react';
import Drawer from '@common/Drawer';
import CheckboxSelector from '@features/viewer/components/CheckboxSelector';

export default function FilterDrawerMonthlyWithYear({
  onClose,
  open,
  onSubmit,
  lastMonth,
  financialYears,
}) {
  const [selectedFy, setSelectedFy] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [selectedStep, setSelectedStep] = useState(1);

  //handle click on submit
  const handleSubmit = () => {
    onSubmit(finalData);
    console.log(">>", finalData)
    setFinalData([]);
    setSelectedStep(1);
  };

  //handle click on clear
  const handleClear = () => {
    setSelectedFy([]);
    setFinalData([]);
  };

  return (
    <Drawer onClose={onClose} open={open}>
      <div className="flex flex-col gap-4">
        {/* title */}
        {selectedStep === 1 ? (
          Array.isArray(lastMonth) ? (
            <div className="flex flex-wrap gap-2">
              {lastMonth.map((l) => (
                <div
                  key={l}
                  className="bg-[#E6F0FF] w-fit rounded-lg py-1 text-xs px-2.5 font-['SF-Pro-Text-Regular, sans-serif'] font-medium text-tertiary-text"
                >
                  {l}
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-[#E6F0FF] w-fit rounded-lg py-1 text-xs px-2.5 font-['SF-Pro-Text-Regular, sans-serif'] font-medium text-tertiary-text">
              {lastMonth}
            </div>
          )
        ) : selectedStep === 2 ? (
          <div className="flex items-center gap-4">
            {selectedFy.map((year) => {
              return (
                <div
                  key={year.shortHand}
                  className="bg-[#E6F0FF] w-fit rounded-lg py-1 text-xs px-2.5 font-['SF-Pro-Text-Regular, sans-serif'] font-medium text-tertiary-text"
                >
                  {year.shortHand}
                </div>
              );
            })}
          </div>
        ) : null}

        {/* content */}
        {selectedStep === 1 ? (
          <CheckboxSelector
            list={financialYears}
            checkedList={selectedFy}
            onItemCheck={setSelectedFy}
            slug="year"
            multiSelect={false}
          />
        ) : selectedStep === 2 ? (
          <CheckboxSelector
            slug="months"
            list={selectedFy[0]}
            checkedList={finalData}
            onItemCheck={setFinalData}
          />
        ) : null}

        {/* actions */}
        <div>
          {selectedStep === 1 ? (
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={handleClear}
                className="bg-[#FFFFFF] text-tertiary-text font-medium text-sm border border-gray-300 rounded-lg px-4 py-2"
              >
                Clear
              </button>
              <button
                onClick={() =>
                  selectedFy.length
                    ? setSelectedStep(2)
                    : message.error('Please select a year')
                }
                className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-lg bg-primary-bg-tint text-secondary-bg"
              >
                Next
              </button>
            </div>
          ) : selectedStep === 2 ? (
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => setSelectedStep(1)}
                className="bg-[#FFFFFF] text-tertiary-text font-medium text-sm border border-gray-300 rounded-lg px-4 py-2"
              >
                Back
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-lg bg-primary-bg-tint text-secondary-bg"
              >
                Submit
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </Drawer>
  );
}
